import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserAuthFacade } from '@state/user-auth';
import { ModalOpts } from './mode-changed-modal.service';

@Component({
  selector: 'app-mode-changed-modal',
  templateUrl: './mode-changed-modal.component.html',
  styleUrls: ['./mode-changed-modal.component.scss'],
  standalone: false,
})
export class ModeChangedModalComponent implements OnInit {
  public data = inject<ModalOpts>(MAT_DIALOG_DATA);
  public dialogRef = inject(MatDialogRef<ModeChangedModalComponent>);
  private readonly userAuthFacade = inject(UserAuthFacade);

  public additionalMessage = '';

  public checkedProcessSteps: string[] = [];

  public branding$ = this.userAuthFacade.branding$;

  public hasAssistantService: boolean;
  public hasFullHandling: boolean;

  public ngOnInit(): void {
    this.hasAssistantService = this.data.userProcess.hasAssistantService;
    this.hasFullHandling = this.data.userProcess.hasFullHandling;
  }

  public close(): void {
    this.dialogRef.close();
  }
}
